removeUtm();

$( ".prodIDs" ).each(function( index ) {
  var prodId = $(this).text();
  hideUnavailableColors('Standard',prodId);
});

$(".o-toggle").click(function(){
  	var size = $(this).find($(".o-toggle__switch.is-active")).html();
  	var prodId = $(this).parents(".c-variant-selector").attr("productid");
    hideUnavailableColors(size,prodId);
});

var numfirstAvailP = $('.firstAvailP').html();
if(numfirstAvailP != ""){
	var availCol = $(".varSel .o-swatch:not(.hiddenCol)").find($("label"));
  	$(availCol[0]).click();
}


let timerId = setInterval(function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, 100);
setTimeout(function() {
    clearInterval(timerId);
}, 100);

function removeUtm(){
  if(window.location.href.indexOf('aftershokz-com?utm_source=') > 0 || window.location.href.indexOf('aftershokz.com/?utm_source=') > 0){
       window.history.pushState({}, document.title, "/" );
   }
}

$('#reviewBt').click(function () {
    $('html, body').animate({
        scrollTop: $('#reviews').offset().top - 200
    }, 500);
    return false;
});

function hideUnavailableColors(sizeSelector,productID){
  var panel = '#' + productID + "__swatches";
  var STD = (panel + ".colorLabels .stdColors");
  STD = $(STD).html();
  var Mini =  (panel + ".colorLabels .miniColors");
  Mini =  $(Mini).html();
  var allColors = (panel + ".colorLabels .allColors1");
  allColors = $(allColors).html().trim().split(', ');
  
  $(allColors).each(function(index,ele){
    if(sizeSelector == 'Mini'){
  		hideSize(Mini,ele,productID);
  	}
  	else{
    	hideSize(STD,ele,productID);
	}
  });
  var availCol = $(".varSel [aria-labelledby='swatch-heading-" + productID + "'] .o-swatch:not(.hiddenCol)").find($("label"));
  $(availCol[0]).click();   
}

function hideSize(missingColor,checkColor,product_ID){
    var colorHandle = checkColor.toLowerCase();
  	if(checkColor.indexOf(' ') != -1){
    	colorHandle = colorHandle.replace(" ", "-");
  	}
	if(missingColor.indexOf('"' + checkColor + '"') != -1){
      $(".varSel [aria-labelledby='swatch-heading-" + product_ID + "'] .o-swatch__fill--" + colorHandle).parents("div.o-swatch").addClass('hiddenCol');
    }
    else{
      $(".varSel [aria-labelledby='swatch-heading-" + product_ID + "'] .o-swatch__fill--" + colorHandle).parents("div.o-swatch").removeClass('hiddenCol');
    }
}

if($('.c-variant-picker__title').text().trim().toUpperCase() == ""){
	$('#reviews').hide();
	$('.c-pdp-gallery__slide').removeClass('c-pdp-gallery__slide--full');
}


$('.afsz-fullimagesM').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	fade: true
}); 
$('.afsz-fullimages').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true, 
	asNavFor: '.afsz-thumbs'
});
$(".afsz-thumbs").slick({ 
	vertical: true,
	infinite: false, 
	asNavFor: ".afsz-fullimages",
	slidesToShow: 5,
	slidesToScroll: 1,
	//verticalSwiping: true,
	focusOnSelect: true,
	//centerMode: true,
	rows: 1
}); 
 

$('.selectedVariantid').val($('#sVariantid').text());

$(".o-swatch").click(function(){     
  var inp = $(this).find("input");
  var selColor =  $(inp).val();
  addSelectedColorImg(selColor);
  document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  $('.selectedVariantid').val($('#sVariantid').text());
});


  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);


function addSelectedColorImg(col){    	
  if($('.afsz-prod-wrapper').hasClass('fl')){
	var selectedColor = "." + col;
  	selectedColor = selectedColor.trim().replace(' ','-');
  
	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickFilter',selectedColor);      
    //$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickGoTo', -1);
  
	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickFilter',selectedColor);	   
    //$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickGoTo', -1);
  
	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
    //$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', -1);
}}


$('#compBt').css('bottom',parseInt($('#compBt').attr('data-bottompos')) + 'em');




function functionAddtoC(id,title,ele){
  
    
	var formData = {
	 'items': [{
	  'id':  '32379695202391',
	  'quantity': '1',
      "properties":{ "For": title }
	  }]
	};
	
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: JSON.stringify(formData), 
    	success: function() { location.href = '/cart'; }
  	});   
  
}


//NIU
function functionProductAddtoC(id){
   
    
	var formData = {
	 'items': [{
	  'id':  id,
	  'quantity': '1',
      "properties":{ "For": " ", "GiftM": " " }
	  }]
	};
	
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: JSON.stringify(formData), 
    	success: function() { location.href = '/cart'; }
  	});   
  
}
 

$('.giftMInputCheck').change(function(){  
  
  var tArea = $(this).parents('label').siblings('.addGiftMArea').find('.giftMInput');
      
  if($(this).prop('checked')==true){
  	$(tArea).attr('disabled',false);
  }
  else{
  	$(tArea).attr('disabled',true);
  }
});


$('.addGiftMCheck').click(function(){    
    var tArea = $(this).parents('.cart__remove').siblings('.addGiftMArea');       
  	$(tArea).toggle('slow'); 
});



function addGiftMessage(product_ID,lineKey,ele){
  
  	var msgTXT = "";
    msgTXT = $(ele).siblings('.giftMInput').val();
    
 	removeProduct(product_ID,lineKey,msgTXT);
  	 //3882354147415
  	
  	
}


function removeProduct(productID,lineKey,msgTXT){
  
	var formData = {
	   'line':  lineKey,
       'quantity': 0
	}
     
  
  	$.ajax({
    	type: 'POST',
    	url: '/cart/change.js',  
    	data: formData, 
    	success: function() {  addProduct(productID,msgTXT) }
  	});  
  
}

function addProduct1(productID,giftMessage){
  
	var formData = {
	 'items': [{
	  'id':  productID,
	  'quantity': '1',
      'properties': { 'GiftM': giftMessage } 
     }]
	};
  
	formData = JSON.stringify(formData);
  
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: formData, 
    	success: function() { location.herf="./cart" }
  	});  
  
}


function addProduct(productID,giftMessage){
  
  	let formData = {
		'items': [{
			'id':  productID,
			'quantity': '1',
			'properties': { 'GiftMessage': giftMessage } 
 		}]
	};

	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(formData)
	})
	.then(response => {
      	console.error(response.json);
		return location.href = '/cart';
	})
	.catch((error) => {
		console.error('Error:', error);
	});  
  
}

function addProductGiftWrap(productID){
  
	var formData = {
	 	'items': [{
	  		 'id':  32379695202391, //Gift Wrap ID
	 		 'quantity': '1',
      		 'properties':{ 'For(Product ID)': productID } 
        }]
	};
  
	formData = JSON.stringify(formData);
  
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: formData, 
    	success: function() { }
  	});  
  
}

function changeProductProp(productID){
  
	alert(productID);
  
}

function changeProductProp1(productID){
  
	var formData = {
	  		 'line':  productID,
      		 'properties': { 'GiftM': 'changed123' } 
        }
    
  	$.ajax({
    	type: 'POST',
    	url: '/cart/change.js',  
    	data: formData, 
    	success: function() { location.href = '/cart'; }
  	});  
  
}


function getItems(){
	$.ajax({
    	type: 'GET',
    	url: '/cart.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json', 
    	success: function(response) { var result = response.items.length; alert(result) }
  	});  
}
  

$('.cart__qty-input').change(function(){ 
  
  changeProductQuantity($(this).parents('tr.cart__row').attr('data-cart-item-index'),$(this).val());
  
});


function changeProductQuantity(ID,Qty){
  
  if(Qty<=0){
  	Qty = 0;
  }
  
    var formData = { 'line':  ID, 'quantity': Qty }     
  
  	$.ajax({
    	type: 'POST',
    	url: '/cart/change.js',  
    	data: formData, 
    	success: function() { location.href = '/cart'; }
  	});  
  
}

